import Screen from '@screen';
import styled from 'styled-components';

const ChannelListCrewContainer = styled.div<React.CSSProperties>`
  margin-top: ${12 * Screen.widthRatio}px;
  height: fit-content;
  width: fit-content;
`;

export default ChannelListCrewContainer;
